import { generateRandomId } from "@variocube/vcmp";
import * as React from "react";
import { useCallback } from "react";
import { stylesheet } from "typestyle";
import { layout } from "../layout.js";
import { classNames } from "../utils.js";
export function Checkbox({ checked, onChange, inline, children, color, size, defaultChecked }) {
    const id = React.useMemo(() => generateRandomId(4), []);
    const handleChange = useCallback((e) => {
        onChange && onChange(e.currentTarget.checked);
    }, [onChange]);
    return (React.createElement("div", { className: classNames(layout.horizontal, layout.alignCenter, styles.checkbox, inline && styles.inline) },
        React.createElement("input", { id: id, type: "checkbox", checked: checked, onChange: handleChange, defaultChecked: defaultChecked, className: classNames(styles.input, color == "primary" && styles.inputPrimary, color == "choice" && styles.inputChoice, size == "large" && styles.large) }),
        React.createElement("label", { htmlFor: id }, children)));
}
const styles = stylesheet({
    checkbox: {
        fontSize: "1em",
    },
    input: {
        width: "1em",
        height: "1em",
        margin: "0 0.25em 0 0",
        flex: "0 0 auto",
    },
    inputPrimary: {
        accentColor: "var(--color-primary)",
    },
    inputChoice: {
        accentColor: "var(--color-choice)",
    },
    large: {
        width: "2em",
        height: "2em",
        margin: "0 0.5em 0 0",
    },
    inline: {
        display: "inline",
    },
});
//# sourceMappingURL=Checkbox.js.map